import React from 'react';
import { ListItem, ListItemText, Stack, Typography } from '@mui/material';
import { GeoTargetingData, GeoTargetType } from 'types';
import { targetTypeTranslationMap } from 'shared';

type GeoAutocompleteOptionProps = {
  listProps: React.HTMLAttributes<HTMLLIElement> & { key: any };
  option: GeoTargetingData;
};

export const GeoAutocompleteOption = ({ listProps, option }: GeoAutocompleteOptionProps) => {
  const { key, ...props } = listProps;
  return (
    <ListItem key={key} {...props}>
      <ListItemText
        primary={
          <Stack width="100%" direction="row" justifyContent="space-between">
            <Typography>{option.name}</Typography>
            <Typography>{targetTypeTranslationMap[option.targetType]}</Typography>
          </Stack>
        }
        secondary={
          option.targetType !== GeoTargetType['Country'] ? (
            <Typography fontSize="12px">{option.canonicalName.split(',').join(', ')}</Typography>
          ) : null
        }
      />
    </ListItem>
  );
};
